import { render } from "./filter_salad.svg?vue&type=template&id=a23644f6?inline"
const script = {}
script.render = render

export default script